import {
  USER_LOCK_FETCH_START,
  USER_LOCK_FETCH_END,
  USER_LOCK_LIST_SUCCESS,
  USER_LOCK_DETAIL_SUCCESS,
} from './ActionTypes';
import axios from '../../../../axios.conf';
import secureLocalStorage from 'react-secure-storage';
import { toast as globalToast } from '../../../../components/ToastManager';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';



const headers = () => ({
  Authorization: secureLocalStorage.getItem('aTk'),
});

export const userLockFetchStart = () => {
  return {
    type: USER_LOCK_FETCH_START,
  };
};

export const userLockFetchEnd = () => {
  return {
    type: USER_LOCK_FETCH_END,
  };
};

export const getUserLocksSuccess = (data) => {
  return {
    type: USER_LOCK_LIST_SUCCESS,
    data,
  };
};

export const getUserLockByIdSuccess = (data) => {
  return {
    type: USER_LOCK_DETAIL_SUCCESS,
    data,
  };
};

export const getUserLocks = () => {
  return async (dispatch) => {
    dispatch(userLockFetchStart());
    try {
      const response = await axios.get('user/locks', { headers: headers() });
      dispatch(getUserLocksSuccess(response.data.response || []));
      dispatch(userLockFetchEnd());
      await handleExecutionLog(dispatch, response?.data?.log_number);
    } catch (error) {
      dispatch(userLockFetchEnd());
    }
  };
};

// Resolves to the lock record, or null on failure, so the caller can fall back.
export const getUserLockById = (id) => {
  return async (dispatch) => {
    dispatch(userLockFetchStart());
    try {
      const response = await axios.get('user/lock/' + id, { headers: headers() });
      const lock = response.data.response || null;
      dispatch(getUserLockByIdSuccess(lock));
      dispatch(userLockFetchEnd());
      await handleExecutionLog(dispatch, response?.data?.log_number);
      return lock;
    } catch (error) {
      dispatch(userLockFetchEnd());
      return null;
    }
  };
};
const runUserLockWrite = async (dispatch, request) => {
  dispatch(userLockFetchStart());
  try {
    const response = await request();
    dispatch(userLockFetchEnd());
    const logNumber = response?.data?.log_number;
    if (logNumber) {
      await handleExecutionLog(dispatch, logNumber);
    } else if (response?.data?.message) {
      globalToast.showSuccess(response.data.message);
    }
    dispatch(getUserLocks());
    return true;
  } catch (error) {
    dispatch(userLockFetchEnd());
    return false;
  }
};

export const createUserLock = (data) => {
  return (dispatch) =>
    runUserLockWrite(dispatch, () => axios.post('user/lock', data, { headers: headers() }));
};

export const updateUserLock = (id, data) => {
  return (dispatch) =>
    runUserLockWrite(dispatch, () => axios.put('user/lock/' + id, data, { headers: headers() }));
};

export const deleteUserLock = (id) => {
  return (dispatch) =>
    runUserLockWrite(dispatch, () => axios.delete('user/lock/' + id, { headers: headers() }));
};

// There is no dedicated release route — a release is an edit that sets is_released.
export const releaseUserLock = (id, data) => {
  return (dispatch) => dispatch(updateUserLock(id, { ...data, is_released: true }));
};
